module.exports = __webpack_public_path__ + "static/img/b2_body.fafc635.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/childrens/b2_body.png
// module id = gehj
// module chunks = 1